import React from 'react';
import { Typography, Button, Wrapper } from '../../ui';

const CreditCardIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="5" width="20" height="14" rx="2" fill="#3498db" />
    <rect x="2" y="8" width="20" height="3" fill="#272d4e" />
    <rect x="4" y="14" width="6" height="2" rx="1" fill="#fff" />
  </svg>
);

const CardConnectorPromo = () => (
  <Wrapper
    mt={4}
    p={3}
    style={{
      border: '1px solid #e0e0e0',
      borderRadius: 12,
      background: '#fff',
    }}
  >
    <Wrapper
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{ gap: 12, flexWrap: 'wrap' }}
    >
      <CreditCardIcon />
      <Typography variant="body1" style={{ fontWeight: 700 }}>
        Credit Card Connector Plugin
      </Typography>
      <span
        style={{
          background: '#ffb800',
          color: '#272d4e',
          fontSize: 11,
          fontWeight: 700,
          padding: '2px 10px',
          borderRadius: 10,
          textTransform: 'uppercase',
        }}
      >
        Free
      </span>
    </Wrapper>
    <Typography
      variant="body2"
      align="center"
      mt={1}
      mb={2}
      style={{ color: '#7f8c8d' }}
    >
      Accept card payments directly in ORO POS — get yours at no cost.
    </Typography>
    <Wrapper display="flex" justifyContent="center">
      <Button
        href="https://shop.orocube.com/cardquote"
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        color="secondary"
        size="small"
      >
        Get It Free
      </Button>
    </Wrapper>
  </Wrapper>
);

export default CardConnectorPromo;
